import { Link } from "react-router-dom"
import Logo from "../components/Logo"
import Card from "../components/Card"
import Button from "../components/Button"
import useForm from "../useForm"


function ForgotPassword() {
    const {handleChange, values, errors, message, setMessage, errmsg, seterrmsg} = useForm({
      email: '',
    });

    const userForgotPassword = async (values) => {
      const signUpOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
    };
      await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, signUpOptions)
        .then( response => response.json())
          .then(data => {
            setTimeout(() => {
              setMessage('')
            },10000)
            setMessage(data.msg)
          })
          .catch(err => {
            console.log(err)
            setTimeout(() => {
              seterrmsg('');
            }, 10000)
            seterrmsg('Something went wrong!');
          })
    } 


     const handleForgotSubmit = (e) => {
       e.preventDefault();
       userForgotPassword(values)
     }
  return (
    <div className='login-container'>
    <Logo />
    <Card>
    {message ? <p className="text-success my-3 message">{message}</p> : 
    <p className="text-danger my-3">{errmsg}</p>}
       <h4 className="card-head">
          Forgot Password
      </h4>
       <p className="card-text"> 
       Enter your email address and we'll send you an email with instructions to reset your password.
       </p>
       <form onSubmit={handleForgotSubmit}>
          <input
           className={errors.ot ? "error login-input gen-input" : "login-input gen-input"}
           type="email" 
           placeholder='Email'
           id="login-email"
           name="email"
           onChange={handleChange}
           value={values.email}/>
             {errors.email && <p className="small">{errors.email}</p>}
          <Button type="submit">
              Submit
          </Button>

       </form>

        <div className="no-account">
            <p>Remember password?</p>
            <Link to='/login' className="link-text sign-up-link">
                Sign in
            </Link>
        </div>
    </Card> 
</div>
  )
}

export default ForgotPassword